import { IconButton } from '@components/core/icon-button.component';
import { useArtifactStore } from '@stores/artifact.store';
import { X, ZoomIn } from 'lucide-react';
import { memo, useState } from 'react';
import { Tile } from '../../../../shared/tile.component';
import { NavyCostTimeReportArtifact } from './navy-cost-time-report-artifact.component';
import { NavyReadinessReportArtifact } from './navy-readiness-report-artifact.component';
import { SankeyArtifact } from './sankey-artifact.component';
import { TechnologyArtifact } from './technology-artifact.component';

export const ArtifactContainer: React.FC = memo(() => {
  const { artifact, hideArtifact } = useArtifactStore();
  const [isFullScreenModalOpen, setIsFullScreenModalOpen] = useState(false);

  if (!artifact) {
    return null;
  }

  const isSankeyArtifact = artifact.kind === 'sankey';

  const openFullScreenModal = () => {
    setIsFullScreenModalOpen(true);
  };

  const closeFullScreenModal = () => {
    setIsFullScreenModalOpen(false);
  };

  return (
    <Tile
      className="z-20 flex h-full min-h-0 min-w-0 w-full flex-col touch-pan-y overscroll-behavior-contain"
      contentClassName="relative flex h-full min-h-0 flex-1 flex-col overflow-hidden"
      header={{
        title: artifact.title,
        iconButton: { icon: <X />, isVisible: true, onClick: hideArtifact },
        actions: isSankeyArtifact ? (
          <IconButton
            icon={<ZoomIn className="size-4" />}
            isVisible={true}
            onClick={openFullScreenModal}
            variant="secondary"
            aria-label="Open full screen"
          />
        ) : undefined,
      }}
    >
      <div className="overscroll-behavior-contain -webkit-overflow-scrolling-touch w-full flex-1 min-h-0 touch-pan-y overflow-y-auto">
        {artifact.kind === 'technology' && <TechnologyArtifact technology={artifact.content} />}
        {artifact.kind === 'armyReadinessReport' && <NavyReadinessReportArtifact report={artifact.content} />}
        {artifact.kind === 'navyCostTimeReport' && <NavyCostTimeReportArtifact report={artifact.content} />}
        {artifact.kind === 'navyReadinessReport' && <NavyReadinessReportArtifact report={artifact.content} />}
        {artifact.kind === 'spaceForceReadinessReport' && <NavyReadinessReportArtifact report={artifact.content} />}
        {artifact.kind === 'sankey' && (
          <SankeyArtifact
            data={artifact.content}
            isFullScreenModalOpen={isFullScreenModalOpen}
            onCloseFullScreenModal={closeFullScreenModal}
          />
        )}
      </div>
    </Tile>
  );
});
